import React from "react";
import OrderListCommonLayer from "./OrderListCommonLayer";

const UnpaidOrdersLayer = () => {
    return (
        <OrderListCommonLayer
            pageTitle="Failed Orders"
            categoryStatus=""
            categoryPayStatus="Unpaid"
        />
    );
};

export default UnpaidOrdersLayer;
